import React, { Suspense } from "react";
import { CircularProgress, Box } from "@mui/material";

const LazyDocumentLibraryPage = React.lazy(() =>
  import("./DocumentLibraryPage").then((mod) => ({
    default: mod.DocumentLibraryPage,
  })),
);

export const DocumentLibraryPage = (): React.JSX.Element => (
  <Suspense
    fallback={
      <Box display="flex" justifyContent="center" p={4}>
        <CircularProgress />
      </Box>
    }
  >
    <LazyDocumentLibraryPage />
  </Suspense>
);
